export const DRAWER_WIDTH = 260;
